import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  content: {
    display: 'flex',
    columnGap: theme.spacing(0.5),
    alignItems: 'center',
  },
  stacked: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(0.5),
  },
  inline: {
    display: 'flex',
    columnGap: theme.spacing(0.5),
    alignItems: 'center',
  },
}));

export default useStyles;
